import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck } from "lucide-react";
import { memo, useState, useEffect } from "react";
import checkmarkIcon from "@/assets/checkmark-icon.png";
const Index = memo(() => {
  const navigate = useNavigate();
  const [isInstalled, setIsInstalled] = useState(false);
  useEffect(() => {
    // Check if app is installed
    if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true) {
      setIsInstalled(true);
    }

    // Listen for app installation
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
    });
  }, []);
  return <div className="min-h-screen bg-background flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background checkmark icon - optimized for LCP */}
      <div className="absolute inset-0 flex items-center justify-center opacity-15 pointer-events-none">
        <img src={checkmarkIcon} alt="" className="w-[600px] h-[600px] object-contain" loading="eager" decoding="async" />
      </div>
      
      <div className="text-center space-y-6 relative z-10">
        <div className="space-y-2">
          <h1 className="bg-gradient-primary bg-clip-text tracking-tight text-5xl font-extrabold text-stone-950">
            BIG TIC-IT
          </h1>
          <p className="text-2xl font-semibold text-foreground/80 tracking-wide">
            YOUR HOME. OUR HANDS
          </p>
        </div>
        <p className="max-w-2xl mx-auto text-base font-medium text-stone-950"> Commerce meets On-Demand Delivery. Find furniture near you, visualize in your space, and get it delivered without leaving the house.</p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button size="lg" onClick={() => navigate('/products')}>
            Explore Products
          </Button>
          <Button size="lg" variant="outline" onClick={() => navigate('/moving-junk')} className="gap-2">
            <Truck className="h-5 w-5" />
            Moving & Junk Removal
          </Button>
          <Button size="lg" variant="outline" onClick={() => navigate('/auth')}>
            Seller Login
          </Button>
          {!isInstalled && <Button size="lg" variant="secondary" onClick={() => navigate('/install')} className="text-stone-50 bg-stone-900 hover:bg-stone-800">
              Install App
            </Button>}
        </div>
      </div>
    </div>;
});
Index.displayName = 'Index';
export default Index;